import {
  SlotConfig,
  defaultSlots,
} from 'quickstart/components/tizra/MetaTile/common'
import * as R from 'rambdax'
import * as B from '../block'
import {BookshelfControls} from './BookshelfControls'
import {Admin, GlobalAdmin} from './admin'
import {useBookshelfConfig, useBookshelfSearch, useBookshelfSort} from './hooks'
import {BookshelfBlockConfig, meta} from './meta'

interface TizraWindow extends Window {
  tizra: any
}

declare let window: TizraWindow

export const BookshelfBlock = B.blockWithInfo(
  {...meta, Admin, GlobalAdmin},
  ({config}: {config: BookshelfBlockConfig}) => {
    const {title} = useBookshelfConfig()
    const userData = B.useUserData()

    return (
      <B.Section heading={title}>
        {
          userData ?
            // The Bookshelf component is defined below.
            <Bookshelf config={config} />
          : userData === false ?
            <B.Text>
              Please{' '}
              <B.Link onClick={() => window.tizra.login()}>sign in</B.Link> to
              see your personalized bookshelf.
            </B.Text>
          : null // waiting for userData
        }
      </B.Section>
    )
  },
)

function Bookshelf({
  config,
  config: {display},
}: {
  config: BookshelfBlockConfig
}) {
  const redemptionConfig = B.useGlobalBlockConfig('redemption')
  const {validSortProps, sortOptions, sorting} = useBookshelfSort({config})
  const {
    search,
    search: {isFetching, lastResults},
  } = {search: useBookshelfSearch({config, sortOptions, sorting})}

  // Compatibility shim for Browse with tiles, since the Bookshelf admin still
  // has images/covers.
  const slots = R.piped(
    defaultSlots,
    R.map((slotConfig: SlotConfig, slotName: string) => ({
      ...slotConfig,
      prop: '',
      enabled:
        slotName === 'cover' ||
        slotName === 'link' ||
        (display === 'covers' && slotName === 'title'),
    })),
  )

  return (
    <>
      <BookshelfControls
        config={config}
        redemptionConfig={redemptionConfig}
        search={search}
        sortProps={validSortProps}
      />
      {lastResults?.length ?
        <B.BrowseGallery
          display="tiles"
          slots={slots}
          imageCropping="full"
          search={search}
        />
      : isFetching ?
        null
      : <B.Text>
          You don't have anything on your personalized bookshelf yet.
        </B.Text>
      }
    </>
  )
}

export {useBookshelfConfig} from './hooks'
